export default __webpack_public_path__ + "static/media/ike-asistencia.18518305.svg";